import { supabaseClient } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { ChildTypeFilter, fetchLayoutCustomizations } from '@data';
import { activeUserIdAtom, useEnsureAtomValue } from '@store';

import { queryKeys } from '../queryKeys';

export const useLayoutCustomizations = (layoutId = -1, childType?: ChildTypeFilter | ChildTypeFilter[]) => {
    const activeUserId = useEnsureAtomValue(activeUserIdAtom);
    return useQuery({
        queryKey: queryKeys.layoutCustomization.key(activeUserId, layoutId, childType),
        queryFn: () => fetchLayoutCustomizations(supabaseClient, layoutId, childType),
        enabled: layoutId > 0,
    });
};

export const P_POSITION_REGEX = /p\d{1,2}$/;
